<template>
    <section class="card card-info card-outline" role="region" id="profile-backend">
        <div class="card-header">
            <h3 class="card-title">
                AutoDJ Service

                <small class="badge badge-pill badge-success" v-if="station_info.backend_running" key="lang_profile_backend_running">Running</small>
                <small class="badge badge-pill badge-danger" v-else key="lang_profile_backend_not_running">Not Running</small>
                <br>
                <small>{{ 'Auto DJ Service' }}</small>
            </h3>
        </div>
        <div class="card-body">
            <p class="card-text">
                {{ totalTracks }}
            </p>

            <div class="buttons" v-if="userCanManageMedia">
                <a class="btn btn-info btn-sm" :href="manageMediaUri" key="lang_profile_manage_media">Tracks Files</a>
                <a class="btn btn-default btn-sm" :href="managePlaylistsUri" key="lang_profile_manage_playlists">Playlists</a>
            </div>
        </div>
        <div class="card-footer">
        <div class="card-actions" v-if="userCanManageBroadcasting">
           <button :disabled="status.restarting || status.processing"  @click.prevent="backendAction(restartUri, 'restarting')" class="btn btn-outline-info btn-sm">
                 <i class="fas fa-redo-alt"></i>
                {{status.restarting? 'restarting...':'Restart'}}
            </button>
           <button :disabled="status.processing || status.restarting"  @click.prevent="backendAction(startUri, 'processing')" class="btn btn-outline-success btn-sm" v-show="!station_info.backend_running">
                 <i class="fas fa-play-circle"></i>
                {{status.processing? 'starting...':'Start'}}
            </button>
           <button :disabled="status.processing || status.restarting"  @click.prevent="backendAction(stopUri, 'processing')" class="btn btn-outline-danger btn-sm" v-show="station_info.backend_running">
                <i class="fas fa-stop-circle"></i>
                {{status.processing? 'stopping...':'Stop'}}
            </button>
        </div>
        </div>
    </section>
</template>
<script>

import { SET_STATION_INFO } from "@/store/mutation-types";
export default {
  data(){

      return {
        userCanManageBroadcasting: true,
        userCanManageMedia: true,
        manageMediaUri: '!#',
        managePlaylistsUri: '!#',
        startUri: 'admin/services/backend/start',
        stopUri: 'admin/services/backend/stop',
        restartUri: 'admin/services/backend/restart',
         status : {
            processing: false,
            restarting: false
        }
  
    }
  },
    computed: {
        totalTracks () {
            return `AutoDJ is currently shuffling from 
            ${this.station.number_of_tracks} uploaded tracks and ${this.station.number_of_playlists}
            playlists
            `
        },
  
    },
    methods: {
    
         async backendAction(uri, key){

             try {
                this.status[key] = true   
                let res =  await axios.post(uri)
                this.$store.commit(SET_STATION_INFO, res.data.data)
                this.status[key] = false
                 
             } catch (error) {
                this.status[key] = false 
                console.log(error);
             }
        }
    }
};
</script>

        